export interface SettingDTO {
  default: any;
  key: string;
  name: string,
  value: any,
  type: string
}

export interface SettingResponse {
  application: SettingDTO[]
  customer: SettingDTO[]
}

export enum SettingsEnum {
  LESS_SUSPICIOUS_ITEM_LIMIT = "lessSuspiciousItemLimit",
  REASONS_FOR_CONCERN_ITEM_LIMIT = "reasonsforConcernItemLimit",
  ALLOW_USERS_TO_TRUST_DOMAINS = "allowUsersToTrustDomains",
  USER_TRUSTED_DOMAINS_LIMIT = "userTrustedDomainsLimit",
  ALLOW_USERS_TO_TRUST_DANGEROUS_TOP_LEVEL_DOMAIN="allowUsersToTrustDangerousTopLevelDomain",
  ENABLE_LOCALIZATION = "enableLocalization",
  ALLOW_REPORT_AS_PHISHING = "allowReportAsPhishing",
  ADMINISTRATOR_EMAIL_TO_REPORT_TO = "administratorEmailToReportTo",
  ENABLE_DELETE_PHISHING_EMAILS = "enableDeletePhishingEmails"
}
